import { render, staticRenderFns } from "./RevenueOptimizeWidget.vue?vue&type=template&id=31f24bbb&scoped=true"
import script from "./RevenueOptimizeWidget.vue?vue&type=script&lang=js"
export * from "./RevenueOptimizeWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f24bbb",
  null
  
)

export default component.exports